export default "__VITE_ASSET__DglUWt6U__"